import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Observable } from 'rxjs';
import { MasterKushStrainCardData } from '../../../../../../../models/print-cards/master-kush-strain-card-data';

@Injectable()
export class MasterKushStrainIndexCardStackBackgroundViewModel extends CardBackgroundViewModel {
  public readonly cardData$: Observable<MasterKushStrainCardData>;
}
